import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { markFeatureRequest, markFeatureRequestError, markFeatureRequestSuccess } from "../../slices/event-management/MarkFeatureSlice";

export const MarkFeatureAPI =
    (data) => async (dispatch) => {
        try {
            dispatch(markFeatureRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.markFeature,
                data: data,
            })
            return dispatch(markFeatureRequestSuccess(response.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(markFeatureRequestError(_error));
        }
    };
